export default "__VITE_ASSET__BhftfJ4C__"